import React from 'react';
import PropTypes from 'prop-types';
import {isAndroid} from '../../utils/Utils';
import {generateRoutePath} from 'epic-common/src/route';

export default class IntroSection extends React.PureComponent {
    static propTypes = {
        history: PropTypes.object,
        launchedCountries: PropTypes.object,
        unavailableCountries: PropTypes.object,
        introContent: PropTypes.object,
        country: PropTypes.string,
        isLoggedIn: PropTypes.bool,
        isSubscribed: PropTypes.bool
    };
    
    clickCTA = (e) => {
        if (this.props.isLoggedIn && !this.props.isSubscribed && !isAndroid()) {
            e.preventDefault();
            this.props.history.push(generateRoutePath('/register-success'));
        }
    }
    
    getCTA() {
        let fromLiveCountries = false;
        let liveCountry = [];
        const {introContent} = this.props;

        if (this.props.launchedCountries) {
            for (const countryInfo of this.props.launchedCountries.countryLaunchedInfo) {
                if (countryInfo.countryCode === this.props.country) {
                    fromLiveCountries = true;
                    liveCountry = countryInfo;
                }
            }
        }

        let fromUnavailableCountries = false;

        if (this.props.unavailableCountries) {
            for (const code of this.props.unavailableCountries.countryCode) {
                if (code === this.props.country) {
                    fromUnavailableCountries = true;
                }
            }
        }

        const showRegularCTA = !fromLiveCountries && !fromUnavailableCountries;
        let ctaSection = null;
        const {androidLink, register} = this.props.introContent;
        let beastLink = register;
        if (isAndroid()) {
            beastLink = androidLink;
        }
        if (showRegularCTA) {
            if (!this.props.isLoggedIn || !this.props.isSubscribed) {
                if (introContent.enablePreRegister) {
                    ctaSection = (
                        <div>
                            <div className="cta-buttons">
                                <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                                    <img src={introContent.androidCTA} alt="Android Link" />
                                </a>
                                <a id="sign-up-btn" href={`${introContent.register}`} onClick={e => this.clickCTA(e)}>
                                    <img src={introContent.pcCTA} alt="PC Link" />
                                </a>
                            </div>
                            <div className="pre-register-gift">
                                <a href={beastLink} onClick={e => this.clickCTA(e)}>
                                    <img src={introContent.preRegisterImg} alt="preregister" />
                                </a>
                            </div>
                        </div>
                    );
                } else {
                    ctaSection = (
                        <div className="cta-buttons">
                            <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                                <img src={introContent.androidCTA} alt="Android Link" />
                            </a>
                            <a id="sign-up-btn" href={`${introContent.register}`}>
                                <img src={introContent.pcCTA} alt="PC Link" />
                            </a>
                        </div>
                    );
                }
            } else {
                ctaSection = (
                    <div className="cta-buttons">
                        <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                            <img src={introContent.androidCTA} alt="Android Link" />
                        </a>
                    </div>
                );
            }
        } else if (fromLiveCountries && !fromUnavailableCountries) {
            ctaSection = (
                <div>
                    <div id="download-from-store" className="placeholder" />
                    <div className="download-from-store">
                        <a id="ios-download" href={liveCountry.iosLink} target="_blank" rel="noopener noreferrer">
                            <img src={this.props.launchedCountries.appStoreImg} alt="Apple Store" />
                        </a>
                        <a id="android-download" href={liveCountry.androidLink} target="_blank" rel="noopener noreferrer">
                            <img src={this.props.launchedCountries.googlePlayImg} alt="Google Play" />
                        </a>
                    </div>
                </div>
            );
        } else if (fromUnavailableCountries) {
            ctaSection = (
                <div className="country-unavailable">
                    <h3>{this.props.unavailableCountries.message}</h3>
                </div>
            );
        } else {
            console.warn('Unable to process CTASection due to fail to match conditions');
        }

        return ctaSection;
    }
    render() {
        const ctaSection = this.getCTA();

        return (
            <div id="introSection" className="section" >
                <div className="background" />
                <h1>Epic Boss Battles</h1>

                <div className="firstBlock">
                    <div className="header-logo" />
                    {ctaSection}
                </div>
            </div>
        );
    }
}
